import ENV from "config/Env";
import { backendQueryKey } from "hooks";

import type { RecallEntity } from "models";

const component = "Recalls";

type RecallsListPayload = {
  vin?: string;
  license_plate?: string;
  dealer_location_id?: number;
};

type RecallsListResponse = {
  recalls: RecallEntity[];
  rdw_recalls: RecallEntity[];
  pon_recalls: RecallEntity[];
  has_convertable_recalls: boolean;
};

export const RecallsQueryKeys = {
  list: (params: RecallsListPayload) => backendQueryKey<RecallsListResponse>({ component, baseUrl: ENV.carBaseURL, endpoint: "/recalls/list", params })
};
